import { ColorTokens, FontFamilyTokens, IconSizeTokens, SizeTypeTokens, IconTokens, FontSizeTokens, ButtonTypeTokens, BorderRadiusTokens, StepperStateToken, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import React, { memo } from 'react';
import { View, FlatList, } from 'react-native';
import Button from '../button/Button';
import Icon from '../icon/Icon';
import Space from '../space/Space';
import Typography from '../typography/Typography';
StepperStateToken;
/**
 * Raw Component with Derived props + Theme
 */
const StepperDistributorBase = ({ data }) => {
    const theme = ThemeProvider.getTheme();
    const borderRadiusMapping = theme.borderRadius;
    const sizeValue = 24;
    const messageStyleProps = React.useMemo(() => ({
        padding: 5,
        alignSelf: 'flex-start',
        borderRadius: borderRadiusMapping[BorderRadiusTokens.BR1],
        backgroundColor: theme.colors[ColorTokens.Grey_Milk_1],
    }), []);
    const renderItems = ({ item, index }) => (React.createElement(React.Fragment, null,
        React.createElement(View, { style: { flexDirection: 'row' } },
            React.createElement(View, { style: {
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                } },
                React.createElement(View, { style: {
                        width: sizeValue,
                        height: sizeValue,
                        borderRadius: sizeValue,
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderWidth: 1,
                        borderColor: item.status === StepperStateToken.FAILED
                            ? theme.colors[ColorTokens.System_Error]
                            : item.status ===
                                StepperStateToken.NOT_STARTED
                                ? theme.colors[ColorTokens.Grey_Charcoal]
                                : theme.colors[ColorTokens.Primary_100],
                        backgroundColor: item.status ===
                            StepperStateToken.COMPLETED
                            ? theme.colors[ColorTokens.White]
                            : item.status ===
                                StepperStateToken.IN_PROGRESS
                                ? theme.colors[ColorTokens.White]
                                : theme.colors[ColorTokens.White],
                    } }, item.status ===
                    StepperStateToken.COMPLETED ? (React.createElement(Icon, { name: IconTokens.Check, size: IconSizeTokens.XS, color: ColorTokens.Primary_100 })) : item.status ===
                    StepperStateToken.IN_PROGRESS ? (React.createElement(Icon, { name: IconTokens.Dot, size: IconSizeTokens.Size56, color: ColorTokens.Primary_100 })) : item.status ===
                    StepperStateToken.FAILED ? (React.createElement(Icon, { name: IconTokens.Cross, size: IconSizeTokens.Size56, color: ColorTokens.System_Error })) : (React.createElement(Icon, { name: IconTokens.Right, size: IconSizeTokens.SM, color: ColorTokens.Primary_100 }))),
                index !== data.length - 1 ? (item.status ===
                    StepperStateToken.COMPLETED ? (React.createElement(View, { style: {
                        flex: 1,
                        minHeight: 30,
                        borderLeftWidth: 1,
                        marginTop: 5,
                        marginBottom: 5,
                        borderColor: theme.colors[ColorTokens.Primary_100],
                    } })) : (React.createElement(View, { style: {
                        flex: 1,
                        minHeight: 30,
                        borderLeftWidth: 1,
                        marginTop: 5,
                        marginBottom: 5,
                        borderColor: theme.colors[ColorTokens.Grey_Chalk],
                    } }))) : (React.createElement(React.Fragment, null))),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(View, { style: {
                    flex: 1,
                    flexDirection: 'column',
                } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                    } },
                    React.createElement(Typography, { label: item.title, numberOfLines: 1, color: ColorTokens.Grey_Night, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM }),
                    item.statusText ? (React.createElement(View, { style: {
                            flex: 1,
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                            width: '100%',
                        } },
                        React.createElement(View, { style: {
                                paddingHorizontal: 12,
                            } },
                            React.createElement(Button, { type: ButtonTypeTokens.SmallGhost, label: 'Edit', labelColor: ColorTokens.Primary_100, fontFamily: FontFamilyTokens.Inter })))) : (React.createElement(React.Fragment, null))),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                item.subTitle ? (React.createElement(Typography, { label: item.subTitle, color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS })) : (React.createElement(React.Fragment, null)),
                React.createElement(Space, { size: SizeTypeTokens.SM }))),
        item.message ? (React.createElement(React.Fragment, null,
            React.createElement(View, { style: messageStyleProps },
                React.createElement(Typography, { label: item.message, numberOfLines: 3, color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS })),
            React.createElement(Space, { size: SizeTypeTokens.Size10 }))) : (React.createElement(React.Fragment, null))));
    return (React.createElement(FlatList, { data: data, renderItem: renderItems, keyExtractor: (item) => item.id }));
};
export default memo(StepperDistributorBase);
export { StepperDistributorBase };
